import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, map, shareReplay, switchMap, take, tap } from 'rxjs/operators';

import { CentralService } from '../../../central.service';
import { ConfigService } from '../../../config.service';
import { BookmarkManagerDialogComponent } from '../../../dialogs/bookmark-manager-dialog/bookmark-manager-dialog.component';
import { CoreApiService } from '../../../core-api.service';
import { ProfileService } from '../../../profile/profile.service';
import { SiteRole } from '../../../shared/enums/site-role.enum';
import { AuthService } from '../../../auth.service';
import { DialogService } from '../../../dialogs';

@Component({
  selector: 'app-top-bar',
  templateUrl: './app-top-bar.component.html',
  styleUrls: ['./app-top-bar.component.scss'],
  host: {
    'test-id': 'app-top-bar',
  },
})
export class AppTopBarComponent implements OnInit {

  version$ = this.configService.getVersion().pipe(
    map(versionObj => `Version ${versionObj.flywheel_release}`)
  )

  // central stuff
  centralEnabled = this.configService.getCentralConfig().enabled;
  centralHomeUrl = this.configService.getCentralConfig().app_url;
  currentTenant$ = this.centralService.getCurrentTenant().pipe(shareReplay(1));
  org$ = this.centralService.getCurrentOrg().pipe(shareReplay(1));
  tenants$ = this.centralService.getTenants().pipe(shareReplay(1));

  // admin / manage site / exhaustive mode
  isSiteAdmin = false;
  exhaustiveMode$ = this.profileService.exhaustiveMode$;

  // bookmarks
  private _reloadBookmarks$ = new BehaviorSubject<void>(undefined);
  bookmarks$ = this._reloadBookmarks$.pipe(
    switchMap(() => this.coreApi.site.bookmarks.get()),
    shareReplay(1)
  );
  // profile
  profile$ = this.profileService.getProfile().pipe(
    filter(p => Boolean(p)),
    tap(p => {
      this.isSiteAdmin = SiteRole.isSiteAdmin(p);
    }),
    shareReplay(1),
  );

  constructor(
    private profileService: ProfileService,
    private configService: ConfigService,
    private coreApi: CoreApiService,
    private dialogService: DialogService,
    private centralService: CentralService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.profileService.openExpiringKeysDialog();
  }

  toggleExhaustiveMode(): void {
    this.exhaustiveMode$.pipe(
      take(1)
    ).subscribe(exhaustiveMode => {
      this.profileService.showAllData = !exhaustiveMode;
    })
  }

  editBookmarks(): void {
    this.bookmarks$.pipe(
      take(1)
    ).subscribe(bookmarks => {
      this.dialogService.open(BookmarkManagerDialogComponent, {
        data: {
          bookmarks: bookmarks,
        },
      }).afterClosed().pipe(take(1)).subscribe(proceed => {
        if (proceed) {
          this._reloadBookmarks$.next();
        }
      });
    })
  }

  logout(): void {
    this.authService.logout();
  }
}
